<template>
  <div class="qw-empty">
    <div class="qw-empty__icon">
      <i :class="icon"></i>
    </div>
    <div class="qw-empty__title">{{ title }}</div>
    <div v-if="description" class="qw-empty__desc">{{ description }}</div>
    <div v-if="$slots.default" class="qw-empty__action">
      <slot />
    </div>
  </div>
</template>

<script>
// 空状态占位：无数据/未选择接入方等场景
// 根类对齐全局 .qw-empty 体系（layout.scss），scoped 仅保留图标底座等全局没有的细节
export default {
    name: 'EmptyState',
    props: {
        title: { type: String, default: '暂无数据' },
        description: { type: String, default: '' },
        icon: { type: String, default: 'el-icon-document' }
    }
}
</script>

<style lang="scss" scoped>
.qw-empty__icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--qw-bg-subtle);
    color: var(--qw-text-muted);

    // 覆盖全局 .qw-empty i 的裸图标尺寸：图标收进底座内
    i {
        font-size: 28px;
    }
}

.qw-empty__action {
    margin-top: 16px;
}
</style>
